// transcricao.js - Transcrição de áudio SEM expor chave no navegador.
//
// Antes: o navegador falava direto com o Groq usando a chave (exposta no site).
// Agora: manda o áudio para o nosso backend (o "porteiro"), que guarda a chave
// em segredo. O navegador só precisa do login da criança (o JWT), nada de chave.

import { API_ENDPOINT } from './api';
import { ReadObject } from './storage';

export const transcreverAudio = async (blob) => {
  // Nome do arquivo conforme o formato gravado (iOS x Android x desktop)
  let fileName = 'audio.wav';
  if (blob.type.includes('webm')) {
    fileName = 'audio.webm';
  } else if (blob.type.includes('mp4')) {
    fileName = 'audio.mp4';
  }

  const form = new FormData();
  form.append('file', blob, fileName);

  // Anexa o login (JWT). NÃO definimos Content-Type: o navegador coloca o
  // limite (boundary) do multipart sozinho.
  const headers = {};
  try {
    const auth = await ReadObject('authentication');
    if (auth && auth.jwt) {
      headers.Authorization = `Bearer ${auth.jwt}`;
    }
  } catch (e) {
    // sem autenticação salva: o backend responde 403 e a tela trata
  }

  const resposta = await fetch(`${API_ENDPOINT}/transcribe`, {
    method: 'POST',
    headers,
    body: form,
  });

  if (!resposta.ok) {
    throw new Error(`Transcrição falhou (status ${resposta.status})`);
  }

  const dados = await resposta.json();
  return dados.text || '';
};
